import React, { Component, Context } from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import orderby from "lodash.orderby";
import { withAuth, IAuthProps } from "../../laco-common/auth/AuthContext";
import { WidgetProps } from "../widgets";
import { IFormState, mapFormStateToProps } from "../../redux/reducers/form";
import { IFormActionDispatches, mapFormDispatchToProps } from "../../redux/actions/form";
import { IForm } from "../../laco-common";
import { NavLink } from "react-router-dom";
import { IFormPage, IPage } from "../../laco-common/base/models/page";
import UISearchInput from "../ui/UISearchInput";

type FormsListState = {
	searchQuery: string;
};

type FormData = {
	name: string;
	isPage?: boolean;
};

class FormsList extends Component<IFormActionDispatches & IFormState & IAuthProps & WidgetProps, FormsListState> {
	state = {
		searchQuery: "",
	};

	get forms(): IForm[] {
		return this.searchForms(this.props.forms);
	}

	get formPages(): IFormPage[] {
		const formPages: IFormPage[] = this.props.formPages;
		const q: string = (this.state.searchQuery || "").toLowerCase();
		if (!q) return formPages;
		return formPages.filter(
			(p: IFormPage) =>
				(p.title && p.title.toLowerCase().includes(q)) ||
				(p.navTitle && p.navTitle.toLowerCase().includes(q)) ||
				// (p.content || "").toLowerCase().includes(q) ||
				(p.headline && p.headline.toLowerCase().includes(q)) ||
				this.searchForms(p.forms)?.length > 0
		);
	}

	componentDidMount() {
		this.props.loadForms(this.props.authContext);
	}

	searchForms(forms: IForm[]) {
		const q: string = (this.state.searchQuery || "").toLowerCase();
		if (!q) return forms;
		return forms.filter(
			(f: IForm) =>
				(f.name && f.name.toLowerCase().includes(q)) ||
				(f.description && f.description.toLowerCase().includes(q))
		);
	}

	getData(forms: IForm[], formPages: IFormPage[]): FormData[] {
		const data = [
			...(forms || []),
			...formPages?.map((p) => {
				return { ...p, name: p.navTitle || p.title, isPage: true };
			}),
		];
		return orderby(data, ["name"]);
	}

	render() {
		let forms: IForm[] = [...(this.forms || [])];
		const formPages: IFormPage[] = this.formPages;
		forms = forms.filter(
			(f: IForm) =>
				!formPages.find((p: IPage) => (Array.isArray(p.formId) ? p.formId.includes(f.id) : p.formId === f.id))
		);
		const formData = this.getData(forms, formPages);
		return (
			<div
				className={clsx(!this.props.isNested && "container", !this.props.page?.noPadding && "section-padding")}
			>
				<div className="blue-box partial-radius mb-5">
					<h1>All Forms</h1>
					<p className="py-2">
						All forms and applications can be submitted online. Search for your form below.
					</p>
					<UISearchInput
						className="inverted"
						inputStyle={{ minWidth: "275px" }}
						placeholder="Enter a keyword or form name"
						onSearch={(val) => this.setState({ searchQuery: val })}
					>
						{!!this.state.searchQuery && (
							<span className="mt-3 ml-4">
								Showing {formData.length} of {this.props.forms?.length + this.props.formPages?.length}
							</span>
						)}
					</UISearchInput>
				</div>
				<ul className="links-list pt-2">
					{(formData || []).map((data: any, i: number) => (
						<li key={i}>
							{data.isPage ? (
								<NavLink to={`${data.path}`}>{data.title}</NavLink>
							) : (
								<NavLink to={`/forms/${data.id}`}>
									{data.name} {!data.active && <span className="text-xs">(Draft)</span>}
								</NavLink>
							)}
						</li>
					))}

					<li>
						<span>
							Didn't find what you're looking for? <NavLink to={"/contact"}>Contact Us</NavLink>
						</span>
					</li>
				</ul>
			</div>
		);
	}
}

export default withAuth(
	connect<IFormState, IFormActionDispatches, WidgetProps>(mapFormStateToProps, mapFormDispatchToProps)(FormsList),
	true
);
